import { render, staticRenderFns } from "./ApplicationWaiting.vue?vue&type=template&id=216750c4&"
import script from "./ApplicationWaiting.vue?vue&type=script&lang=js&"
export * from "./ApplicationWaiting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports